import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InitialProps {
  activeIndex: number | null;
  isEditing?: boolean;
  isFormOpen?: boolean;
  util?: string;
}

const initialState: InitialProps = {
  activeIndex: 1,
  isEditing: false,
  isFormOpen: false,
  util: undefined,
};

const collectionSlice = createSlice({
  name: "collectionData",
  initialState,
  reducers: {
    onUpdateActiveIndex: (state, action: PayloadAction<number | null>) => {
      state.activeIndex = action.payload;
    },
    onUpdateIsEditing: (state, action: PayloadAction<boolean>) => {
      state.isEditing = action.payload;
    },
    onUpdateIsFormOpen: (state, action: PayloadAction<boolean>) => {
      state.isFormOpen = action.payload;
    },
    onUpdateUtil: (state, action: PayloadAction<string | undefined>) => {
      state.util = action.payload;
    },
  },
});

export const {
  onUpdateActiveIndex,
  onUpdateIsEditing,
  onUpdateIsFormOpen,
  onUpdateUtil,
} = collectionSlice.actions;

export default collectionSlice.reducer;
